import invariant from 'invariant';
import React from 'react';

import { FileUploadTypes } from 'api/types/shared.types';
import MultiInput from 'components/Multi/MultiInput';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const MultiInputField = ({
  name,
  component,
  label,
  description,
  matchGeneralError,
  placeholder,
  maxInputs,
  type = 'text',
  disabled,
  collapsible,
  extraData,
  extraAnalyticsData,
  hideControls,
  addText,
  removeText,
  showEmpty,
  startWithNone,
  errors,
  defaultData,
  sortBy,
  onError,
}: {
  name: string;
  component?: React.ElementType;
  label?: string;
  description?: string;
  matchGeneralError?: string;
  placeholder?: string;
  maxInputs: number;
  type?: string;
  disabled?: boolean;
  collapsible?: boolean;
  extraData?: Array<{
    customErrorMatch?: (
      arg0: APIErrors
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) => Record<string, any> | null | undefined;
    includeCity?: boolean;
    includeFull?: boolean;
    label?: string;
    placeholder?: string;
    isRequired?: boolean;
    fileType?: FileUploadTypes;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onUpdateValue?: (...args: Array<any>) => any;
    listingType?: string;
  }>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraAnalyticsData?: Array<Record<string, any>>;
  hideControls?: boolean;
  addText?: string;
  removeText?: string;
  showEmpty?: boolean;
  startWithNone?: boolean;
  errors?: APIErrors;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultData?: any;
  sortBy?: (
    arg0: {
      value: unknown;
      index: number;
    },
    arg1: {
      value: unknown;
      index: number;
    }
  ) => number;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError?: (...args: Array<any>) => any;
}) => (
  <Field
    name={name}
    label={label}
    description={description}
    matchGeneralError={matchGeneralError}
    renderInput={({ value, id, qaId, updateValueWith, hasGeneralError }) => {
      invariant(
        Array.isArray(value),
        `Invalid value for MultiInputField named ${name}: ${value}`
      );
      return (
        <MultiInput
          id={id}
          component={component}
          name={name}
          type={type}
          values={value}
          hasError={hasGeneralError}
          maxInputs={maxInputs}
          data-qa-id={qaId}
          placeholder={placeholder}
          onChange={updateValueWith}
          disabled={disabled}
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ id: string; component: ElementType<any>; n... Remove this comment to see the full error message
          collapsible={collapsible}
          extraData={extraData}
          extraAnalyticsData={extraAnalyticsData}
          hideControls={hideControls}
          addText={addText}
          removeText={removeText}
          showEmpty={showEmpty}
          startWithNone={startWithNone}
          defaultData={defaultData}
          errors={errors}
          sortBy={sortBy}
          onError={onError}
        />
      );
    }}
  />
);

// eslint-disable-next-line import/no-default-export
export default MultiInputField;
